import React from 'react';

import './styles.scss'

const Footer = () => (
	<footer className={'footer'} column={true}>
		<div className={'wrapper'}>
			<span className={'footer-copyright'}>{`© ${(new Date()).getFullYear()} Merchants Partners, LLC.`}</span>
			<span className={'footer-notice'}>
				An arm of <a href={'https://hollcompany.com'}>Holl & Company</a>
			</span>
		</div>
	</footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer/index.jsx